import styled from 'styled-components';

export const DataContainer = styled.p`
  display: flex;
  width: 50%;
  font-size: 16px;

  @media (max-width: 750px) {
    width: 100%;
  }

  &.mediumlength {
    width: 40%;

    @media (max-width: 750px) {
      width: 100%;
    }
  }
  &.mininumlength {
    width: 15%;

    @media (max-width: 750px) {
      width: 100%;
    }
  }

  &.singlelabel {
    width: 100%;
  }
`;
export const ViewRowWrapper = styled.div`
  display: flex;
  gap: 100px;
  &.viewgroup {
    gap: 35px;
  }
  &.elemtwrapuser {
    gap: 7px;
  }
  @media (max-width: 750px) {
    & {
      flex-direction: column;
      gap: 0;
    }
  }
`;
export const Data = styled.span`
  margin-left: 10px;
`;
export const Label = styled.strong``;
export const ViewUserConatiner = styled.div`
  width: auto;
  font-size: 16px;
  &.groupviewlist {
    font-size: 18px;
    margin-bottom: 10px;
    padding-left: 0.5em;
  }
  .ant-tabs-tab {
    font-size: 16px !important;
  }
`;
export const GroupTabContainer = styled.div`
  font-size: 16px;
  &.groupviewlist {
    margin-bottom: 10px;
    padding-left: 0.5em;
  }
`;
export const UserStatusWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const UserStatusContentWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 15px;
  margin-right: 100px;
`;
export const UserStatusContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const UserStatusBottomWrap = styled.div`
  display: flex;
  gap: 60px;
  height: 15px;
  margin-top: 32px;
`;
